import { DEFAULT_DIALOG_CONFIG, DialogConfig } from '@angular/cdk/dialog';
import { OVERLAY_DEFAULT_CONFIG } from '@angular/cdk/overlay';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { ApplicationConfig, provideBrowserGlobalErrorListeners, provideZonelessChangeDetection } from '@angular/core';
import { provideSignalFormsConfig } from '@angular/forms/signals';
import { NG_STATUS_CLASSES } from '@angular/forms/signals/compat';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { API_BASE_URL } from '@app/core/auth/auth-config';
import { authInterceptor } from '@app/core/auth/auth-interceptor';
import { ConsoleLogger } from '@app/core/logging/console-logger';
import { LogLevel } from '@app/core/logging/log-level';
import { Logger } from '@app/core/logging/logger';
import { PopIn } from '@app/design-system/pop-in/pop-in';
import { environment } from '../environments/environment';
import { APP_ROUTES } from './app.routes';

export const appConfig: ApplicationConfig = {
    providers: [
        provideBrowserGlobalErrorListeners(),
        provideZonelessChangeDetection(),
        provideRouter(
            APP_ROUTES,
            withComponentInputBinding(),
        ),
        provideHttpClient(withInterceptors([ authInterceptor ])),
        provideSignalFormsConfig({
            classes: NG_STATUS_CLASSES,
        }),
        {
            provide: API_BASE_URL,
            useValue: environment.apiBaseUrl,
        },
        {
            provide: Logger,
            useFactory: (): Logger => {
                if (environment.production) {
                    // Implement separate logger for production?
                    return new ConsoleLogger(LogLevel.WARN);
                }
                return new ConsoleLogger(LogLevel.DEBUG);
            },
        },
        {
            provide: OVERLAY_DEFAULT_CONFIG,
            useValue: {
                usePopover: false
            },
        },
        {
            provide: DEFAULT_DIALOG_CONFIG,
            useValue: {
                hasBackdrop: true,
                container: PopIn,
            } as DialogConfig,
        },
    ],
};
